import React, { useEffect, useState, Fragment } from 'react'
import fp from 'lodash/fp'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { createStructuredSelector } from 'reselect'

import * as attendanceActions from 'redux/modules/model/attendance'
import AttendanceSchedule from './attendance-schedule'
import { Button, Col, Row, PreLoader, TextInput } from 'elements'
import { Pagination } from 'antd'
import { scheduleStatsSelector, detectablesSheduleStatsLoadingSelector } from 'redux/selectors'
import { sortSchedules } from 'utils/helpers'
import { withClientId } from 'hocs'
import { jsonToQueryString, parseQueryString } from "utils/helpers";
import * as ROUTES from "config/routes";

const SearchField = TextInput.Search;

const predicate = (criteria) => (item) => {
  if (criteria.search) {
    return item.name.toUpperCase().includes(criteria.search.toUpperCase())
  }
  return true
}

function AttendanceSchedules(props) {
  // * react hooks
  const [search, setSearch] = useState('');
  // * second arg [] empty arr - have effect of DidMount/UnMount
  useEffect(()=>{
    const { clientId, location, schedules } = props
    if(Array.isArray(schedules) && schedules.length === 0){
      props.listScheduleStatsRequest({ clientId });
    }
    const params = parseQueryString(location.search)
    setSearch(params.search)
  }, [props.schedules])

  function handlePrint () {
    window.print()
  }

  function setURLHref (params){
    const { history } = props
    history.push({
      location: ROUTES.ATTENDANCE_SCHEDULES,
      search: jsonToQueryString(params)
    })
  };

  function handlePageChange (page, perPage) {
    const { location } = props
    const params = {
      ...parseQueryString(location.search),
      page,
      perPage
    }
    setURLHref(params)
  };

  function onSearchChange (e) {
    const { location } = props
    setSearch(e.target.value);
    const params = {
      ...parseQueryString(location.search),
      search: e.target.value,
      page: '1'
    }
    setURLHref(params)
  }

    const { schedules, loading } = props
    const params = parseQueryString(location.search)
    const {page = 1, perPage = 10} = params
    const criteria = {
      ...params,
      search: search || params.search
    }
    const filteredSchedules = sortSchedules(fp.filter(predicate(criteria))(schedules))
    const min = (parseInt(page, 10) * parseInt(perPage, 10)) - parseInt(perPage, 10);
    const max = parseInt(min, 10) + parseInt(perPage, 10);
    const filtered = filteredSchedules.filter((s,i)=>{
      if( i < max && i >= min) return s
    })
    return (
      <div className="section-to-print">
        <Row type="flex" justify="center" align="middle">
          <Col md={6} xs={24}>
            <h1>Modules</h1>
          </Col>
          <Col md={10} xs={24}>
            <SearchField
              placeholder="Search by Name"
              value={search}
              onChange={onSearchChange}
            />
          </Col>
          <Col md={8} xs={24} className="text-right">
            <Button className="no-print" onClick={handlePrint}>Print</Button>
          </Col>
        </Row>
        {loading ? <PreLoader /> : (
          <Fragment>
            {filtered.map((schedule) => (
              <AttendanceSchedule
                key={schedule.scheduleId}
                scheduleId={schedule.scheduleId}
                title={schedule.name}
                attendance={schedule.overallAttendance}
                processedBlockCount={schedule.processedBlockCount}
                startDate={schedule.startTime}
                endDate={schedule.endTime}
                committerCount={schedule.committerCount}
                blockCount={schedule.blockCount}
              />
            ))}
            <Row type={'flex'} justify={'end'}>
              <Col xs={24}>
                <Pagination
                  style={{float: 'right'}}
                  defaultCurrent={1}
                  total={filteredSchedules.length}
                  defaultPageSize={10}
                  showSizeChanger
                  size={'small'}
                  showTotal={(total)=>`${total} Modules`}
                  current={parseInt(page, 10)}
                  pageSize={parseInt(perPage, 10)}
                  pageSizeOptions={['10','15','50','100']}
                  onChange={(page, pageSize) => handlePageChange(page, pageSize)}
                  onShowSizeChange={(current, size) => handlePageChange(1, size)}
                />
              </Col>
            </Row>
          </Fragment>
        )}
      </div>
    )
}

const selector = createStructuredSelector({
  schedules: scheduleStatsSelector,
  loading: detectablesSheduleStatsLoadingSelector
})

export const actions = {
  listScheduleStatsRequest: attendanceActions.listScheduleStats
}

export default compose(
  withClientId,
  withRouter,
  connect(selector, actions)
)(AttendanceSchedules);



// WEBPACK FOOTER //
// ./src/pages/attendance/attendance-schedules/index.js